import React, { Component }from 'react';
import { Panel } from 'react-bootstrap';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import { withStyles } from '@material-ui/core/styles';

class AccordionChild extends Component {

    render() {
        const { classes, title, keyAccordion, componentToRender, keyboardCommandKey } = this.props;
        const displayChild = this.props.dontDisplay? false : true;
        return (
            <Panel eventKey={keyAccordion} style={displayChild? {} : {display: 'none'}}>
                <Panel.Heading>
                    <Panel.Toggle componentClass="div">
                        <div style={{color: '#333333', fontFamily: "Work Sans", fontSize: 20, fontWeight: 400}}>
                            {title}
                            
                            <KeyboardArrowDown 
                                className={classes.userArrow} 
                                onClick={this.handleMenu} 
                                style={{ height: 20, float: 'right' }} 
                            />
                            <div style={{ height: 20, fontSize: 14, float: 'right' }} >
                               ({keyboardCommandKey})
                            </div>
                        </div>
                    </Panel.Toggle>
                </Panel.Heading>
                <Panel.Body collapsible>
                    {componentToRender}
                </Panel.Body>
            </Panel>
        );
    }
}

export default withStyles(null)(AccordionChild);

